
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_REQUEST_ERROR = 'LOGIN_REQUEST_ERROR';

export const REDIRCT_LOGIN = 'REDIRCT_LOGIN';